import React, { useEffect, useState, useRef } from "react";
import "../../../assets/css/PhoneSlider.css";
import NoCopyWrapper from "../../../utils/NoCopyWrapper";
import screen1 from "../../../assets/img/fruntphone-14-1-3.png";
import screen2 from "../../../assets/img/midelIphone-14-4.png";
import screen3 from "../../../assets/img/thirdphone-14-3-1.png";
import NoZoomWrapper from "../../../utils/NoZoomWrapper";
const images = [screen1, screen2, screen3];

const PhoneSlider = () => {
  const [index, setIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const mouseDown = useRef(false);

  // auto slide
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const handleNext = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setIndex((prev) => (prev + 1) % images.length);
    setTimeout(() => setIsAnimating(false), 600);
  };

  const handlePrev = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setIndex((prev) => (prev - 1 + images.length) % images.length);
    setTimeout(() => setIsAnimating(false), 600);
  };

  // touch events
  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const onTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const onTouchEnd = () => {
    if (touchStartX.current - touchEndX.current > 50) handleNext();
    if (touchStartX.current - touchEndX.current < -50) handlePrev();
  };

  // mouse drag events
  const onMouseDown = (e) => {
    mouseDown.current = true;
    touchStartX.current = e.clientX;
  };
  const onMouseMove = (e) => {
    if (!mouseDown.current) return;
    touchEndX.current = e.clientX;
  };
  const onMouseUp = () => {
    mouseDown.current = false;
    if (touchStartX.current - touchEndX.current > 50) handleNext();
    if (touchStartX.current - touchEndX.current < -50) handlePrev();
  };

  return (
    <NoZoomWrapper>
      <NoCopyWrapper>
        <div
          className="phone-slider"
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
          onMouseDown={onMouseDown}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUp}
        >
          {images.map((img, i) => {
            let position = "phone hidden";

            if (i === index) {
              position = "phone phone-center";
            } else if (i === (index - 1 + images.length) % images.length) {
              position = "phone phone-left";
            } else if (i === (index + 1) % images.length) {
              position = "phone phone-right";
            }

            return (
              <div key={i} className={position}>
                <img src={img} alt={`slide-${i}`} />
              </div>
            );
          })}
        </div>
      </NoCopyWrapper>
    </NoZoomWrapper>
  );
};

export default PhoneSlider;
